import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
// import { PetRegistrationService } from '../service/pet-registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { Color, ScaleType, colorSets } from '@swimlane/ngx-charts';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { KlManageService } from '../service/kl-manage.service';
@Component({
  selector: 'app-klm-dashboard',
  templateUrl: './klm-dashboard.component.html',
  styleUrls: ['./klm-dashboard.component.css']
})
export class KlmDashboardComponent {
  ebillUser: any;
  b_acct_id: any;
  pieChartData: any = [];






  constructor(public spinner: NgxSpinnerService,
    private toastr: ToastrService,public KlManageService :KlManageService) { }
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;

    await this.gettotalbooking()

   

  }
  total_booking:any
  async gettotalbooking() {
     
    await this.currentDate();
    this.monthObj['startOfCurrentMonth'] = `${this.currYear}-${this.currMonth}-01`;
    this.monthObj['endOfCurrentMonth'] = `${this.currYear}-${this.currMonth}-${await this.daysInMonth(this.currMonth, this.currYear)}`
    this.monthObj['startOfPreviousMonth'] = `${this.currYear}-${(this.currMonth - 1)}-01`
    this.monthObj['endOfPreviousMonth'] = `${this.currYear}-${(this.currMonth - 1)}-${await this.daysInMonth((this.currMonth - 1), this.currYear)}`

    this.dayObj['currentDay'] = this.currDate;
    this.dayObj['previousDay'] = `${this.currYear}-${this.currMonth}-${(this.currDay - 1)}`;
    let obj :any= {}
    
    obj['b_acct_id']=this.b_acct_id
    obj['monthObj'] = this.monthObj;
    obj['dayObj'] = this.dayObj;
    let resp3: any = await this.KlManageService.getDashboardLineChart(obj);
    if (resp3['error'] == false) {
      let arr = [
        {
          "name": "Current",
          "series": resp3['data']
        }
      ]
      this.lineChartData = arr;
      console.log(this.lineChartData)
    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Server side error! Please contact to the admin', 'info');
      return;
    }
    let resp = await this.KlManageService.ggetbookingdasboardpiechartdata(JSON.stringify(obj))
    if(resp["error"]==false){
      this.total_booking=resp.data[0]['value']+resp.data[1]['value']
      this.pieChartData = resp['data'];

    }
    else {
      this.spinner.hide();
      Swal.fire('Error', 'Server side error! Please contact to the admin', 'info');
      return;
    }
 

  }



  totalAmountOfCurrentDate: any;
  pendingAmount: any;
  totalEarning: any;


  currMonth: any
  currYear: any
  currDate: any
  currDay: any
  async currentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = parseInt(('0' + (today.getMonth() + 1)).slice(-2))
    const day = parseInt(('0' + today.getDate()).slice(-2));
    this.currDate = `${year}-${month}-${day}`;
    this.currMonth = month;
    this.currYear = year;
    this.currDay = day;
  }



  monthObj: any = {}

  dayObj: any = {}

  async daysInMonth(month: any, year: any) {
    return new Date(year, month, 0).getDate();
  }


  dashboardAnalyticsPercentage: any = {}



  // ////////////////////////////////////////////////////////////////////

  colorScheme1: Color = {
    name: 'custom',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['rgba(44, 182, 125, 1)', 'rgba(35, 183, 229, 1)']
  };

  showLegend = false;
  showLabels = true;
  explodeSlices = false;
  doughnut = true;
  gradient = true;

  onSelect(event: any): void {
    console.log(event);
  }




  view2: [number, number] = [700, 350];

  showXAxis = true;
  showYAxis = true;
  showXAxisLabel = true;
  xAxisLabel = "Month";
  showYAxisLabel = true;
  yAxisLabel = "Revenue";
  autoScale = true;


  public onSelect2(event: any): void {
    console.log(event);
  }
  lineChartData: any
  

}




